import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=d8a3eee0&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a3eee0')) {
      api.createRecord('d8a3eee0', component.options)
    } else {
      api.reload('d8a3eee0', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=d8a3eee0&", function () {
      api.rerender('d8a3eee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUh9a3P9PJMR/JS/ImageCarousel.vue"
export default component.exports